<template>
  <div class="usuarios-editar">
    <b-card>
      <div v-if="cargando" class="text-center py-4">
        <b-spinner variant="primary" />
        <p class="mt-2">Cargando usuario...</p>
      </div>

      <div v-else-if="error" class="text-center py-4">
        <b-alert variant="danger" show>
          {{ error }}
        </b-alert>
        <b-button variant="primary" @click="cargarUsuario">
          Reintentar
        </b-button>
      </div>

      <div v-else>
        <h3 class="mb-2">Editar usuario</h3>

        <b-form @submit.prevent="guardar">
          <b-form-group label="Nombre">
            <b-form-input v-model.trim="form.nombre" required />
          </b-form-group>

          <b-form-group label="Primer Apellido">
            <b-form-input v-model.trim="form.primerApellido" required />
          </b-form-group>

          <b-form-group label="Segundo Apellido">
            <b-form-input v-model.trim="form.segundoApellido" />
          </b-form-group>

          <b-form-group label="Email">
            <b-form-input type="email" v-model.trim="form.email" required />
          </b-form-group>

          <b-form-group label="Rol">
            <b-form-select v-model.number="form.idRol" :options="roleOptions" required />
          </b-form-group>

          <b-form-group label="Contraseña (opcional)">
            <b-form-input type="password" v-model.trim="form.contrasena" placeholder="Dejar en blanco para no cambiar" autocomplete="new-password" />
          </b-form-group>
          <b-form-group label="Confirmar contraseña" v-if="form.contrasena">
            <b-form-input type="password" v-model.trim="form.contrasena2" autocomplete="new-password" />
            <small v-if="!passwordsCoinciden" class="text-danger">Las contraseñas no coinciden</small>
          </b-form-group>

          <b-button type="submit" variant="primary" :disabled="guardando || (form.contrasena && !passwordsCoinciden)">
            {{ guardando ? 'Guardando...' : 'Guardar' }}
          </b-button>
          <b-button variant="secondary" class="ml-1" @click="cancelar">Cancelar</b-button>
        </b-form>
      </div>
    </b-card>
  </div>
</template>

<script>
import usuarioService from '@/services/usuarioService'
import rolService from '@/services/rolService'

export default {
  name: 'UsuariosEditar',
  data() {
    return {
      cargando: false,
      guardando: false,
      error: null,
      roleOptions: [],
      form: {
        nombre: '',
        primerApellido: '',
        segundoApellido: '',
        email: '',
        idRol: null,
        contrasena: '',
        contrasena2: '',
      },
    }
  },
  computed: {
    idUsuario() {
      return Number(this.$route.params.id)
    },
    passwordsCoinciden() {
      return this.form.contrasena === this.form.contrasena2
    }
  },
  async mounted() {
    await Promise.all([this.cargarRoles(), this.cargarUsuario()])
  },
  methods: {
    async cargarRoles() {
      try {
        const roles = await rolService.getAllRoles()
        this.roleOptions = roles.map(r => ({ value: r.idRol, text: r.nombre }))
      } catch (e) {
        this.roleOptions = []
      }
    },
    async cargarUsuario() {
      this.cargando = true
      this.error = null
      try {
        const usuario = await usuarioService.getUsuarioById(this.idUsuario)
        this.form = {
          nombre: usuario.nombre,
          primerApellido: usuario.primerApellido,
          segundoApellido: usuario.segundoApellido || '',
          email: usuario.email,
          idRol: usuario.idRol,
        }
      } catch (e) {
        this.error = 'No se pudo cargar el usuario'
      } finally {
        this.cargando = false
      }
    },
    async guardar() {
      this.guardando = true
      try {
        const payload = {
          nombre: this.form.nombre,
          primerApellido: this.form.primerApellido,
          segundoApellido: this.form.segundoApellido || undefined,
          email: this.form.email,
          idRol: this.form.idRol,
        }
        if (this.form.contrasena) {
          payload.contrasena = this.form.contrasena
        }
        await usuarioService.updateUsuario(this.idUsuario, payload)
        this.$toast.success('Usuario actualizado correctamente')
        this.$router.push({ name: 'usuarios-detalle', params: { id: this.idUsuario } })
      } catch (e) {
        this.$toast.error('Error al actualizar usuario')
      } finally {
        this.guardando = false
      }
    },
    cancelar() {
      this.$router.push({ name: 'usuarios-detalle', params: { id: this.idUsuario } })
    }
  }
}
</script>

<style lang="scss" scoped>
.usuarios-editar {
  padding: 1.5rem;
}
</style>


